const listFrom20To90: string[] = [
    'vinte',
    'trinta',
    'quarenta',
    'cinquenta',
    'sessenta',
    'setenta',
    'oitenta',
    'noventa',
]

export default listFrom20To90
